import { get } from "lodash";
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes";
var isAppOnly = function (deal) {
    return get(deal, "typeHighlight") === DealHighlightTypes.APP_ONLY;
};
export default isAppOnly;
